import { IOfferScopeCrudModalLang } from '../../../types/lang'

export const offerScopeCrudModalLang: IOfferScopeCrudModalLang = {
	offer_scope_crud_modal: {
		title_create: 'Create offer scope_ua',
		title_edit: 'Edit offer scope_ua',
		title_remove_single: 'Remove <span>offer scope_ua</span>',
		title_notes_view: 'View notes for offer scope_ua',
		title_notes_edit: 'Edit notes for offer scope_ua',
		field_name_label: 'Name_ua',
		field_name_placeholder: 'Name_ua',
		field_cap_label: 'Cap_ua',
		field_cap_placeholder: 'Cap_ua',
		field_cap_type_label: 'Cap Type_ua',
		field_cap_type_placeholder: 'Cap Type_ua',
		field_status_label: 'Status_ua',
		field_status_placeholder: 'Status_ua',
		field_notes_label: 'Notes_ua',
		field_notes_placeholder: 'Notes_ua',
		msg_remove_confirm: 'Are you sure?_ua',
		btn_create: 'Create_ua',
		btn_update: 'Save_ua',
		btn_remove: 'Remove_ua',
		btn_close: 'Close_ua'
	}
}